import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VmeCommonModule } from '../../../vme-common.module';
import { VmePipesModule } from '../../../vme-pipes.module';
import { PillComponent } from '../../supplier-risk-management/components/pill/pill.component';
import { IOrderBookingSummary } from '../../../interfaces/order-booking-health-check/order-booking-health-check';
import { AMPriorityEnum } from '../../../enums/am-priority.enum';

@Component({
  selector: 'booking-list-item',
  standalone: true,
  imports: [CommonModule, VmeCommonModule, VmePipesModule, PillComponent],
  templateUrl: './booking-list-item.component.html',
})
export class BookingListItemComponent {
  @Input() booking: IOrderBookingSummary;
  @Input() isSelected: boolean = false;

  @Output() selectedBookingChange = new EventEmitter<number>();

  protected readonly AMPriorityEnum = AMPriorityEnum;

  // The first and last legs of the booking, which is what the queue row summarises.
  get firstTask() {
    return this.booking.tasks?.length ? this.booking.tasks[0] : null;
  }

  get lastTask() {
    return this.booking.tasks?.length ? this.booking.tasks[this.booking.tasks.length - 1] : null;
  }

  get issueCountLabel(): string {
    return `${this.booking.openIssueCount} ${
      this.booking.openIssueCount === 1 ? 'Issue' : 'Issues'
    }`;
  }
}
